/* eslint-disable no-return-await */
import axiosClient from './axiosClient';

export const getTenants = async () => await axiosClient.get(`${process.env.REACT_APP_USM_API_BASE_URL}/v2/tenants`);

export const getSingleTenant = async (id) => await axiosClient.get(`${process.env.REACT_APP_USM_API_BASE_URL}/v2/tenants/${id}`);
